import { Button } from "../../../Common/AbstractComponents/Button";
import AjaxBuilder from "../../../Common/AjaxBuilder";
import { Util } from "../../../Common/Util";

export class ErrorTextModule {
    constructor({ page, infoPopup }) {
        this.$page = page;
        this._infoPopup = infoPopup;
        this.$newsWrapper = this.$page.find('.single_news_content');
        this.$popup = $('#news_popup_error-text');
        this.$popupBtn = this.$popup.find('.btn');
        this._btn = new Button({
            button: this.$popupBtn,
            onClick: this._sendErrorText.bind(this),
        })
        this._text = null;

        this._init();
    }

    _init() {
        this.$newsWrapper.on('mouseup', this._selectText.bind(this));
        $(document).keydown(this._showPopup.bind(this));
    }

    _selectText(event) {
        this._text = this._getSelectedText();
        // $('#error_text_popup .text > span').text(text);
    }

    _getSelectedText() {
        let text = '';
        if (window.getSelection) {
            text = window.getSelection().toString();
        } else if (document.selection) {
            text = document.selection.createRange().text;
        }
        return text;
    }

    _showPopup(event) {
        if (event.ctrlKey && event.keyCode == 13) {
            event.preventDefault();

            if (this._text === null || !this._text.trim()) return false;

            this._show();
        }
    }

    _sendErrorText(event) {
        event.preventDefault();

        new AjaxBuilder({
            route: this.$popup.data('route'),
            data: {
                token: Util.token(),
                comment: this.$popup.find('#comment').val(),
                text: this._text,
                news_id: this.$popup.data("news"),
            },
            token: Util.token(),
        }, 'POST').execute({
            success: this._sendErrorTextSuccess.bind(this),
            error: this._sendErrorTextFailed.bind(this),
        });
    }

    _sendErrorTextSuccess(data) {
        this.$popup.find('#comment').val('');
        this._hide();
        this._infoPopup.show({
            title: data.response.title,
            message: data.response.message,
        });
    }

    _sendErrorTextFailed(data) {
        this.$popup.find('#comment').val('');
        this._hide();
        this._infoPopup.show({
            title: data.response.title,
            message: data.response.message,
        });
    }

    _show() {
        this.$popup.find('.message_error').html(this._text);
        $('html').addClass('_open_bus_popup');
        $('.news_overlay').addClass('_active');
        $(this.$popup).addClass('_active');
    }

    _hide() {
        this.$popup.find('#comment').val('');
        $('html').removeClass('_open_bus_popup');
        $('.news_overlay').removeClass('_active');
        $('.news_popup').removeClass('_active');
        $('.popup_places').removeClass('_active');
    }
}